import * as types from './mutation-types'

export default {
    [types.LOAD_QUESTIONS] (state, data) {
        state.questions = data.questions
    },
}

